import React from "react";
import GaziosmanpasaSidebar from "../Sidebar/GaziosmanpasaSidebar";
import GaziosmanpasaOtherServices from "../ServiceAreas/GaziosmanpasaServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const GaziosmanpasaIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        GAZİOSMANPAŞA HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Gaziosmanpaşa'da halı ve koltuklarınız artık daha hijyenik ve daha sağlıklı. Gelişmiş
            teknolojilerle donatılmış ekipmanlarımız sayesinde, yaşam alanlarınızı kirden, tozdan ve
            mikroorganizmalardan arındırıyoruz. Profesyonel ekibimiz, tüm temizlik işlemlerini özenle
            gerçekleştirir.
          </p>

          <p>
            Halılarınız türüne göre özel yıkama programlarına tabi tutulur. Koltuklar ise yerinde ya da
            fabrikada buharlı ve antibakteriyel yöntemlerle yıkanarak, ilk günkü temizliğine kavuşur.
          </p>

          <p>
            <strong>Hizmetlerimizin öne çıkan avantajları şunlardır:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Gaziosmanpaşa’nın tüm mahallelerinden ücretsiz alım ve teslimat</li>
            <li>Hassas kumaşlara özel temizlik çözümleri</li>
            <li>Organik ve sağlığa zarar vermeyen temizlik ürünleri</li>
            <li>Antibakteriyel koltuk yıkama sistemleri</li>
            <li>Yorgan, battaniye ve perde yıkama hizmeti</li>
            <li>Hızlı servis ve 48 saat içerisinde teslimat garantisi</li>
          </ul>

          <p>
            Karayolları, Yenidoğan, Sarıgöl, Mevlana, Merkez Mahallesi ve Karlıtepe gibi bölgelerde
            aktif olarak hizmet sunuyoruz. Mobil araçlarımızla adresinize kadar gelip temizlik ürünlerinizi teslim alıyoruz.
          </p>

          <p>
            Tüm halılar, önce toz alma işleminden geçirilir, ardından tam otomatik makinelerde yıkanır
            ve kurutularak steril bir şekilde paketlenir. Koltuklar ise özel buhar makineleri ve fırçalama
            sistemleriyle detaylı şekilde temizlenir.
          </p>

          <p>
            Gaziosmanpaşa bölgesinde hızlı, kaliteli ve güvenilir temizlik hizmeti arıyorsanız bize ulaşın.
            Web sitemiz veya iletişim numaramız üzerinden sipariş verebilir, fiyat bilgisi alabilirsiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <GaziosmanpasaSidebar />
          <GaziosmanpasaOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default GaziosmanpasaIntro;
